import React from "react";
import { Link } from "react-router-dom";
import commonStyles from "../../Shared/commonStyles.module.css";
import CTAStyles from "./CallToAction.module.css";

function CallToAction({
  paragraph,
  productsText = "Browse Products",
  occasionsText = "Shop by Occasion",
}) {
  return (
    <section className={`${commonStyles.section}`}>
      <div className={commonStyles.container}>
        <div className={CTAStyles.final}>
          <h2>Ready to send something meaningful?</h2>
          <p>{paragraph}</p>
          <div className={commonStyles.heroCtas}>
            <Link
              to="/products"
              className={`${commonStyles.btn} ${commonStyles.btnPrimary}`}
            >
              {productsText}
            </Link>
            <Link
              to="/occasions"
              className={`${commonStyles.btn} ${commonStyles.btnSecondary}`}
            >
              {occasionsText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
